/* eslint-disable no-useless-catch */
import React from "react";
import PromiseRender from "./PromiseRender";

/**
 * Common check permissions method
 * @param { Permission judgment } authority
 * @param { Your permission description } currentAuthority
 * @param { Passing components } target
 * @param { no pass components } Exception
 */
function checkPermissions(authority, target, configPerm, Exception) {
  // Retirement authority, return target;
  if (authority === undefined) {
    return target;
  }

  if (typeof authority === "boolean") {
    if (authority) {
      return target;
    }

    return Exception;
  }

  if (Object.keys(configPerm || {}).length === 0) {
    // still loading
    return null;
  }

  if (Array.isArray(authority)) {
    const hasPermission = authority.some(permission => {
      return configPerm[permission];
    });

    if (hasPermission) {
      return target;
    }

    return Exception;
  } // string

  if (typeof authority === "string") {
    if (configPerm[authority]) {
      return target;
    }

    return Exception;
  } // Promise

  if (authority instanceof Promise) {
    return <PromiseRender ok={target} error={Exception} promise={authority} />;
  } // Function

  if (typeof authority === "function") {
    try {
      const bool = authority(configPerm); // Promise

      if (bool instanceof Promise) {
        return <PromiseRender ok={target} error={Exception} promise={bool} />;
      }

      if (bool) {
        return target;
      }

      return Exception;
    } catch (error) {
      throw error;
    }
  }

  throw new Error("unsupported parameters");
}

export default checkPermissions;
